import React from 'react'

import MarkdownHelper from "../../utils/MarkdownHelper";
import ReactMarkdown from "react-markdown";

const BrandPageMediaText = ({ title, copy }) => {
    return (
        <div className="brand-page-media-text bg-white px-md py-md">
            <div className="brand-page-media-text-text">
                <div className="brand-page-media-text-text_title">
                    <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                   source={title}
                                   escapeHtml={false} />
                </div>
                <div className="brand-page-media-text-text_copy">
                    <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                   source={copy}
                                   escapeHtml={false} />
                </div>
            </div>
        </div>
    )
}

export default BrandPageMediaText



// WEBPACK FOOTER //
// ./src/components/ads/brandPage/BrandPageMediaText.js